import {api} from "@/app/services/api.service";

const state = {
    copyrightAssignmentTransfer:null,
    copyrightAssignmentTransferError:null,
    copyrightAssignmentTransferTask:null,
    copyrightAssignmentTransferTaskError:null,
    copyrightAssignmentTransferTaskCount:null,
    copyrightAssignmentTransferTaskCountError:null,
    copyrightAssignmentTransferTaskUpdateStatus:null,
    copyrightAssignmentTransferTaskUpdateStatusError:null,
    copyrightAssignmentTransferStatistics:null,
    copyrightAssignmentTransferStatisticsError:null,
    copyrightAssignmentTransfers:null,
    copyrightAssignmentTransfersError:null,
    copyrightAssignmentTransferTaskMessages:null,
    copyrightAssignmentTransferTaskMessagesError:null,
    copyrightAssignmentTransferEscalation:null,
    copyrightAssignmentTransferEscalationError:null,
    copyrightAssignmentTransferEscalations:null,
    copyrightAssignmentTransferEscalationsError:null,
    copyrightAssignmentTransferRegistry:null,
    copyrightAssignmentTransferRegistryError:null,
};

const getters = {
    getCopyrightAssignmentTransferTask: (state) => state.copyrightAssignmentTransferTask,
    getCopyrightAssignmentTransferTaskError: (state) => state.copyrightAssignmentTransferTaskError,
    getCopyrightAssignmentTransferTaskCount: (state) => state.copyrightAssignmentTransferTaskCount,
    getCopyrightAssignmentTransferTaskCountError: (state) => state.copyrightAssignmentTransferTaskCountError,
    getCopyrightAssignmentTransferTaskUpdateStatus: (state) => state.copyrightAssignmentTransferTaskUpdateStatus,
    getCopyrightAssignmentTransferTaskUpdateStatusError: (state) => state.copyrightAssignmentTransferTaskUpdateStatusError,
    getCopyrightAssignmentTransferStatistics: (state) => state.copyrightAssignmentTransferStatistics,
    getCopyrightAssignmentTransferStatisticsError: (state) => state.copyrightAssignmentTransferStatisticsError,
    getCopyrightAssignmentTransfers: (state) => state.copyrightAssignmentTransfers,
    getCopyrightAssignmentTransfersError: (state) => state.copyrightAssignmentTransfersError,
    getCopyrightAssignmentTransferTaskMessages: (state) => state.copyrightAssignmentTransferTaskMessages,
    getCopyrightAssignmentTransferTaskMessagesError: (state) => state.copyrightAssignmentTransferTaskMessagesError,
    getCopyrightAssignmentTransfer: (state) => state.copyrightAssignmentTransfer,
    getCopyrightAssignmentTransferError: (state) => state.copyrightAssignmentTransferError,
    getCopyrightAssignmentTransferEscalation: (state) => state.copyrightAssignmentTransferEscalation,
    getCopyrightAssignmentTransferEscalationError: (state) => state.copyrightAssignmentTransferEscalationError,
    getCopyrightAssignmentTransferEscalations: (state) => state.copyrightAssignmentTransferEscalations,
    getCopyrightAssignmentTransferEscalationsError: (state) => state.copyrightAssignmentTransferEscalationsError,
    getCopyrightAssignmentTransferRegistry: (state) => state.copyrightAssignmentTransferRegistry,
    getCopyrightAssignmentTransferRegistryError: (state) => state.copyrightAssignmentTransferRegistryError,
};

const actions = {
    async fetchCopyrightAssignmentTransferTask({commit}){
        await api().get("copy-right/api/v1/transactions/task/queue").
        then(async response => {
            if (response.data && response.data.data && response.data.data.applicationId) {
                const task = response.data.data;
                await api().get("copy-right/api/v1/transactions/id/" + task.applicationId).
                then(detailsResponse => {
                    const applicationDetails = detailsResponse.data && detailsResponse.data.data ? detailsResponse.data.data : null;
                    const combined = {
                        ...response.data,
                        data: {
                            ...applicationDetails,
                            id: task.id,
                            applicationId: task.applicationId,
                            assignedTo: task.assignedTo,
                            status: task.status,
                            createdAt: task.createdAt,
                            updatedAt: task.updatedAt
                        }
                    };
                    commit('setCopyrightAssignmentTransferTask', { data: combined });
                }).catch(error => {
                    commit("setCopyrightAssignmentTransferTaskError", error.response);
                });
            } else {
                commit('setCopyrightAssignmentTransferTask', response);
            }
        }).catch(error => {
            commit("setCopyrightAssignmentTransferTaskError", error.response)
        });
    },
    async fetchCopyrightAssignmentTransferTaskCount({commit}){
        await api().get("copy-right/api/v1/applications/queue/count").
        then(response => {
            commit('setCopyrightAssignmentTransferTaskCount', response.data);
        }).catch(error => {
            commit("setCopyrightAssignmentTransferTaskCountError", error.response)
        });
    },
    async updateCopyrightAssignmentTransferTaskStatus({commit}, data){
        const payload = {
            applicationId: data.applicationId || data.copyrightAssignmentTransferId || "",
            taskId: data.taskId || data.queueId || "",
            status: data.status || "APPROVED",
            message: data.message || data.reason || "Application updated.",
            officerNotes: data.officerNotes || data.message || data.reason || ""
        };
        await api().post("copy-right/api/v1/transactions/task/action", payload).
        then(response => {
            commit('setCopyrightAssignmentTransferTaskUpdateStatus', response.data);
        }).catch(error => {
            commit("setCopyrightAssignmentTransferTaskUpdateStatusError", error.response)
        });
    },
    async fetchCopyrightAssignmentTransferStatistics({commit}){
        await api().get("copy-right/api/v1/transactions/stats").
        then(response => {
            commit('setCopyrightAssignmentTransferStatistics', response.data);
        }).catch(error => {
            commit("setCopyrightAssignmentTransferStatisticsError", error.response)
        });
    },
    async fetchAllCopyrightAssignmentTransferApplications({commit}, data) {
      let path="copy-right/api/v1/transactions?status="+data.status+"&page="+data.page+"&pageSize="+data.limit;

      if(data.startRegistrationDate){
        path+="&dateOfEffectStart="+data.startRegistrationDate
      } if(data.endRegistrationDate){
        path+="&dateOfEffectEnd="+data.endRegistrationDate
      }
        await api()
            .get(path)
            .then(response => {
                commit('setCopyrightAssignmentTransfers', response.data);
            }).catch(error => {
                commit("setCopyrightAssignmentTransfersError", error.response)
            });
    },
    async fetchCopyrightAssignmentTransferTaskMessages({commit}, data){
        let taskId = "";
        let path = "copy-right/api/v1/applications/task/messages/";
        if (typeof data === "object" && data !== null) {
            taskId = data.id || data.taskId || "";
            path += taskId;
            let params = [];
            if (data.page !== undefined) params.push("page=" + data.page);
            if (data.limit !== undefined) params.push("limit=" + data.limit);
            if (data.status !== undefined) params.push("status=" + data.status);
            if (params.length > 0) {
                path += "?" + params.join("&");
            }
        } else {
            taskId = data;
            path += taskId;
        }
        await api().get(path).
        then(response => {
            commit('setCopyrightAssignmentTransferTaskMessages', response.data);
        }).catch(error => {
            commit("setCopyrightAssignmentTransferTaskMessagesError", error.response)
        });
    },
    async fetchCopyrightAssignmentTransferByTrackingNumber({commit}, trackingNumber) {
        await api()
            .get("copy-right/api/v1/assignments/find/" + trackingNumber)
            .then((response) => {
                commit("setCopyrightAssignmentTransfer", response.data);
            })
            .catch((error) => {
                commit("setCopyrightAssignmentTransferError", error.response);
            });
    },
    async fetchCopyrightAssignmentTransferByReservationNumber({commit}, reservationNumber) {
        await api()
            .get("copy-right/api/v1/applications/by-reservation-no/" + reservationNumber)
            .then((response) => {
                commit("setCopyrightAssignmentTransfer", response.data);
            })
            .catch((error) => {
                commit("setCopyrightAssignmentTransferError", error.response);
            });
    },
    async escalateCopyrightAssignmentTransferTask({commit, state}, data) {
        commit("setCopyrightAssignmentTransferEscalation", null);
        let appId = "";
        if (state.copyrightAssignmentTransferTask && state.copyrightAssignmentTransferTask.data && state.copyrightAssignmentTransferTask.data.applicationId) {
            appId = state.copyrightAssignmentTransferTask.data.applicationId;
        } else if (state.copyrightAssignmentTransfer && state.copyrightAssignmentTransfer.id) {
            appId = state.copyrightAssignmentTransfer.id;
        } else if (state.copyrightAssignmentTransfer && state.copyrightAssignmentTransfer.data && state.copyrightAssignmentTransfer.data.id) {
            appId = state.copyrightAssignmentTransfer.data.id;
        }
        const payload = {
            applicationId: data.applicationId || appId || "",
            taskId: data.taskId || data.queueId || "",
            userId: data.userId || data.registrarId || "",
            message: data.message || data.comment || ""
        };
        await api()
            .post("copy-right/api/v1/applications/task/escalate", payload)
            .then((response) => {
                commit("setCopyrightAssignmentTransferEscalation", response.data);
            })
            .catch((error) => {
                commit("setCopyrightAssignmentTransferEscalationError", error.response);
            });
    },
    async fetchCopyrightAssignmentTransferEscalations({commit}, data){
        await api().get("copy-right/api/v1/applications/task/escalations?page="+data.page+"&perPage="+data.limit).
        then(response => {
            commit('setCopyrightAssignmentTransferEscalations', response.data);
        }).catch(error => {
            commit("setCopyrightAssignmentTransferEscalationsError", error.response)
        });
    },
    async fetchCopyrightAssignmentTransferRegistry({commit}, data) {
        let path = "copy-right/api/v1/copyright-assignment-transfer/registry?page=" + data.page + "&pageSize=" + data.limit;
        if (data.search) {
            path += "&search=" + data.search;
        }
        if (data.certificateNumber) {
            path += "&certificateNumber=" + data.certificateNumber;
        }
        if (data.title) {
            path += "&title=" + data.title;
        }
        if (data.startDate) {
            path += "&startDate=" + data.startDate;
        }
        if (data.endDate) {
            path += "&endDate=" + data.endDate;
        }
        await api()
            .get(path)
            .then(response => {
                commit("setCopyrightAssignmentTransferRegistry", response.data);
            })
            .catch(error => {
                commit("setCopyrightAssignmentTransferRegistryError", error.response);
            });
    },
};

const mutations = {
    setCopyrightAssignmentTransferTask:(state, response) =>{
        state.copyrightAssignmentTransferTask = response.data
    },
    setCopyrightAssignmentTransferTaskError:(state, response) =>{
        state.copyrightAssignmentTransferTaskError = response.data
    },
    setCopyrightAssignmentTransferTaskCount:(state, response) =>{
        state.copyrightAssignmentTransferTaskCount = response && response.data ? response.data : response
    },
    setCopyrightAssignmentTransferTaskCountError:(state, response) =>{
        state.copyrightAssignmentTransferTaskCountError = response.data
    },
    setCopyrightAssignmentTransferTaskUpdateStatus:(state, response) =>{
        state.copyrightAssignmentTransferTaskUpdateStatus = response
    },
    setCopyrightAssignmentTransferTaskUpdateStatusError:(state, response) =>{
        state.copyrightAssignmentTransferTaskUpdateStatusError = response.data
    },
    setCopyrightAssignmentTransferStatistics:(state, response) =>{
        const stats = response && response.data ? response.data : response;
        if (stats) {
            const approved = stats.approved || 0;
            const assigned = stats.assigned || 0;
            const pending = stats.pending || 0;
            const rejected = stats.rejected || 0;
            const draft = stats.draft || 0;
            const escalated = stats.escalated || stats.myAssigned || 0;
            const queried = stats.queried || 0;
            const total = stats.total || (approved + assigned + pending + rejected + draft + escalated + queried);

            state.copyrightAssignmentTransferStatistics = {
                draft,
                pending,
                assigned,
                escalated,
                queried,
                approved,
                rejected,
                total
            };
        } else {
            state.copyrightAssignmentTransferStatistics = null;
        }
    },
    setCopyrightAssignmentTransferStatisticsError:(state, response) =>{
        state.copyrightAssignmentTransferStatisticsError = response.data
    },
    setCopyrightAssignmentTransfers:(state, response) => {
        state.copyrightAssignmentTransfers = response
    },
    setCopyrightAssignmentTransfersError:(state, error) => {
        state.copyrightAssignmentTransfersError = error
    },
    setCopyrightAssignmentTransferTaskMessages: (state, response) => {
        let content = [];
        if (response && response.data) {
            if (Array.isArray(response.data.content)) {
                content = response.data.content;
            } else if (Array.isArray(response.data)) {
                content = response.data;
            }
        } else if (response && Array.isArray(response.content)) {
            content = response.content;
        } else if (Array.isArray(response)) {
            content = response;
        }

        state.copyrightAssignmentTransferTaskMessages = content.map(msg => {
            if (msg.messageData) {
                return msg;
            }
            return {
                ...msg,
                messageData: {
                    sender: [msg.senderFirstName, msg.senderLastName].filter(Boolean).join(' ') || msg.senderId || 'System',
                    senderRole: msg.senderAccountType || '',
                    comment: msg.message || '',
                    createdAt: msg.createdAt
                }
            };
        });
    },
    setCopyrightAssignmentTransferTaskMessagesError: (state, response) =>{
        state.copyrightAssignmentTransferTaskMessagesErrors = response.data;
    },
    setCopyrightAssignmentTransfer: (state, response) =>{
        state.copyrightAssignmentTransfer = response.data;
    },
    setCopyrightAssignmentTransferError: (state, response) =>{
        state.copyrightAssignmentTransferError = response.data;
    },
    setCopyrightAssignmentTransferEscalation: (state, response) =>{
        state.copyrightAssignmentTransferEscalation = response;
    },
    setCopyrightAssignmentTransferEscalationError: (state, response) =>{
        state.copyrightAssignmentTransferEscalationError = response.data;
    },
    setCopyrightAssignmentTransferEscalations: (state, response) => {
        state.copyrightAssignmentTransferEscalations = response;
    },
    setCopyrightAssignmentTransferEscalationsError: (state, response) => {
        state.copyrightAssignmentTransferEscalationsError = response.data;
    },
    setCopyrightAssignmentTransferRegistry: (state, response) => {
        state.copyrightAssignmentTransferRegistry = response;
    },
    setCopyrightAssignmentTransferRegistryError: (state, response) => {
        state.copyrightAssignmentTransferRegistryError = response.data;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
